import { Component, DebugElement, OnDestroy, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  CreateKompenzacijuCommand,
  IKompenzacijaDto,
  KompenzacijeClient,
  UpdateKompenzacijuCommand,
  VrstaRacuna,
} from '@kodit/core/data-api';
import {
  FormHelper,
  KompenzacijaFormService,
} from '@kodit/core/form-definitions';
import {
  AlertService,
  LocationService,
  SharedService,
} from '@kodit/core/services';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';
import { KompenzacijaService } from '../kompezacija.service';
import { forEach } from 'lodash';

@Component({
  selector: 'kodit-kompenzacija-form',
  templateUrl: './kompenzacija-form.component.html',
  styleUrls: ['./kompenzacija-form.component.scss'],
})
export class KompenzacijaFormComponent implements OnInit, OnDestroy {
  private _subs: Subscription;

  /** Props */
  kompenzacijaForm: FormGroupTypeSafe<IKompenzacijaDto>;
  vrstaRacuna: VrstaRacuna;
  vrstaRacunaIzlazni = VrstaRacuna.IZLAZNI;

  jeMojaFirmaPoverilac: boolean;
  stareVrednostiPremaPoveriocu: number[] = [];
  stareVrednostiPremaDuzniku: number[] = [];
  brojObavezaDuznika: number;
  brojObazvezaPoverioca: number;
  brojeviRacuna: string[] = [];


  kompenzacijaId: number = 0;
  jeEditMode: boolean = false;

  constructor(
    private _route: ActivatedRoute,
    private _kompenzacijaFormService: KompenzacijaFormService,
    private _service: KompenzacijaService,
    private _formHelper: FormHelper,
    private _kompenzacijeClient: KompenzacijeClient,
    private _alertService: AlertService,
    private _locationService: LocationService,
    private _breadcrumbService: BreadcrumbService,
    private _sharedService: SharedService
  ) {
    this._subs = new Subscription();
  }

  ngOnInit(): void {
    this._route.data.subscribe((data) => {
      if (data['vrstaRacuna']) {
        this.vrstaRacuna = data['vrstaRacuna'] as VrstaRacuna;
      }
      if (data.racun && data.racun['kompenzacijaId']) {
        this.kompenzacijaId = data.racun['kompenzacijaId'] as number;
        this.jeEditMode = true;
      }
    });
    // ToDo: add model za edit...
    this.kompenzacijaForm = this._kompenzacijaFormService.GetKompenzacijaFormGroup(
      this.vrstaRacuna
    );
    this._service.setForm = this.kompenzacijaForm;

    if (this.jeEditMode) {
      this._subs.add(
        this._kompenzacijeClient
          .getKompenzacijaById(this.kompenzacijaId)
          .subscribe((res) => {
            this.patchFormByModel(res.data);
            this._setBreadcrumb();
            this._service.dodajStareVrednosti();
          })
      );

    }
    this.jeMojaFirmaPoverilac = this.vrstaRacuna == VrstaRacuna.IZLAZNI;

    // pri menjanju stranke brisemo odabrane postojece kompenzacione obaveze
    this.kompenzacijaForm.controls.stranka.valueChanges.subscribe(() => {
      this._resetKompenzacioneObaveze();
      this._service.dodajStareVrednosti();
    });

    this._service.resetObaveze();

  }

  onSave() {
    if (!this.kompenzacijaForm.valid) {
      this._formHelper.invalidateForm(this.kompenzacijaForm);
      return;
    }

    if (this.jeIzmenjeno()) {
      this._alertService.addWarnMsg(
         `Ne možete da unesete veći iznos od ukupnog iznosa računa u obavezama. Uneli ste veći iznos za sledeće račune: ${this.brojeviRacuna}.`
      );
      return;
    }

    if(!((this.kompenzacijaForm?.controls.obavezePremaDuzniku as FormArray).length == 1 && (this.kompenzacijaForm?.controls.obavezePremaPoveriocu as FormArray).length == 1)){
      var vrednostPremaPoveriocu = 0.0;
      const obavezePremaPoveriocu = this.kompenzacijaForm.controls.obavezePremaPoveriocu as FormArray;
      obavezePremaPoveriocu.controls.forEach((control, index) => {
        vrednostPremaPoveriocu = vrednostPremaPoveriocu + control.value.iznos;

      });

      var vrednostPremaDuzniku = 0.0;
      const obavezePremaDuzniku = this.kompenzacijaForm.controls.obavezePremaDuzniku as FormArray;
      obavezePremaDuzniku.controls.forEach((control, index) => {
        vrednostPremaDuzniku = vrednostPremaDuzniku + control.value.iznos;
      });

      if(vrednostPremaPoveriocu != vrednostPremaDuzniku){
        this._alertService.addWarnMsg(
          `Ukoliko unesete više obaveza, suma treba biti jednaka za obe strane kako bi kompenzacije bile ispravne.`
        );
        return;
      }
    }

    if (
      (this.kompenzacijaForm?.controls.obavezePremaDuzniku as FormArray).length === 1 &&
      (this.kompenzacijaForm?.controls.obavezePremaPoveriocu as FormArray).length === 1
    ) {
      const duznikVrednost = this._service.stareVrednostiDuznika[0];
      const poverilacVrednost = this._service.stareVrednostiPoverioca[0];
      const manjaVrednost = Math.min(duznikVrednost, poverilacVrednost);

      const iznosDuznika = this.kompenzacijaForm.value.obavezePremaDuzniku[0].iznos;
      const iznosPoverioca = this.kompenzacijaForm.value.obavezePremaPoveriocu[0].iznos;

      if (duznikVrednost > poverilacVrednost && iznosDuznika > manjaVrednost) {
        this._alertService.addWarnMsg(
          `Obaveze prema poveriocu su veće u odnosu na ukupan preostali iznos računa ${this.kompenzacijaForm.value.obavezePremaPoveriocu[0].broj} na strani dužnika.`
        );
        return;
      }

      if (poverilacVrednost > duznikVrednost && iznosPoverioca > manjaVrednost) {
        this._alertService.addWarnMsg(
          `Obaveze prema dužniku su veće u odnosu na ukupan preostali iznos računa ${this.kompenzacijaForm.value.obavezePremaDuzniku[0].broj} na strani poverioca.`
        );
        return;
      }
    }

    // everything is ok, let's save it
    if (this.jeEditMode) {
      this._sharedService.displayLoadingScreen(
        true,
        'Ažuriranje kompenzacije...'
      );
      this._subs.add(
        this._kompenzacijeClient
          .updateKompenzaciju(
            this.kompenzacijaForm.value as UpdateKompenzacijuCommand
          )
          .subscribe((res) => {
            this._alertService.addSuccessMsg(res.data);
            this._locationService.routeBack();
          })
      );
    } else {
      this._sharedService.displayLoadingScreen(
        true,
        'Kreiranje kompenzacije...'
      );
      this._subs.add(
        this._kompenzacijeClient
          .create(this.kompenzacijaForm.value as CreateKompenzacijuCommand)
          .subscribe((res) => {
            this._alertService.addSuccessMsg(res.messages[0]);
            this._locationService.routeBack();
          })
      );
    }
  }

  patchFormByModel(model: IKompenzacijaDto) {
    this.kompenzacijaForm.patchValue(model);
    (this.kompenzacijaForm?.controls.obavezePremaDuzniku as FormArray).clear();
    (this.kompenzacijaForm?.controls
      .obavezePremaPoveriocu as FormArray).clear();

    model.obavezePremaPoveriocu.forEach((x) => {
      (this.kompenzacijaForm?.controls.obavezePremaPoveriocu as FormArray).push(
        this._kompenzacijaFormService.GetObavezeFormGroup(x)
      );
    });

    model.obavezePremaDuzniku.forEach((x) => {
      (this.kompenzacijaForm?.controls.obavezePremaDuzniku as FormArray).push(
        this._kompenzacijaFormService.GetObavezeFormGroup(x)
      );
    });
  }

  private _setBreadcrumb() {
    this._breadcrumbService.set(
      '@izmenaKompenzacije',
      `Izmena kompenzacije ${this.kompenzacijaForm.value.broj}`
    );
  }

  private _resetKompenzacioneObaveze() {
    (this.kompenzacijaForm.controls.obavezePremaPoveriocu as FormArray).clear();
    (this.kompenzacijaForm.controls.obavezePremaDuzniku as FormArray).clear();
    (this.kompenzacijaForm.controls.obavezePremaDuzniku as FormArray).push(
      this._kompenzacijaFormService.GetObavezeFormGroup()
    );
    (this.kompenzacijaForm.controls.obavezePremaPoveriocu as FormArray).push(
      this._kompenzacijaFormService.GetObavezeFormGroup()
    );

  }

  private jeIzmenjeno(): boolean {
    let izmenjeno = false;
    this.brojeviRacuna = [];

    const obavezePremaPoveriocu = this.kompenzacijaForm.controls.obavezePremaPoveriocu as FormArray;
    obavezePremaPoveriocu.controls.forEach((control, index) => {
      const trenutniIznos = control.value.iznos;
      const pocetniIznos = this._service.stareVrednostiPoverioca[index];
      if (trenutniIznos > pocetniIznos) {
        izmenjeno = true;
        this.brojeviRacuna.push(control.value.broj);
      }
    });

    const obavezePremaDuzniku = this.kompenzacijaForm.controls.obavezePremaDuzniku as FormArray;
    obavezePremaDuzniku.controls.forEach((control, index) => {
      const trenutniIznos = control.value.iznos;
      const pocetniIznos = this._service.stareVrednostiDuznika[index];
      if (trenutniIznos > pocetniIznos) {
        izmenjeno = true;
        this.brojeviRacuna.push(control.value.broj);
      }
    });

    return izmenjeno;
  }

  onCancel() {
    this._locationService.routeBack();
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
